import { ENDPOINTS } from '@/shared/api/endpoints';
import { request } from '@/shared/api/request';

import type { ChangePasswordPayload } from '../model/auth.schema';

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  await request<unknown, ChangePasswordPayload>({
    method: 'POST',
    url: ENDPOINTS.auth.changePassword,
    data: payload,
  });
}
